;(function($, window, document, undefined) {

	const pluginName = 'multilevelPushMenu';

	class MultilevelPushMenu {

		constructor(element, options) {

			this._name = pluginName;
			this._defaults = $.fn[pluginName].defaults;

			this.element = element;
			this.settings = $.extend(true, this._defaults, options);

			this.init();

		}

		init() {

			this.isActive = false;
			this.activeLevels = [];

			this.cacheElements();
			this.bindEvents();

		}

		cacheElements() {
			this.$element = $(this.element);
			this.$menu = this.settings.menu;
			this.$submenus = this.settings.submenus;
			this.$content = this.settings.content;
			this.$smartHeader = this.settings.smartHeader;
			this.$toggler = this.settings.toggler;
			this.$backButtons = this.settings.backButtons;
			this.$shareBarFixed = this.settings.shareBarFixed;


		}

		bindEvents() {

			this.$toggler.on('click', this.toggleMenu.bind(this));
			this.$submenus.siblings('a').on('click', this.openSubmenu.bind(this));
			this.$backButtons.on('click', this.hideSubmenu.bind(this));
			this.$menu.on('click', '.' + this.settings.classes.active, this.selectSubmenu.bind(this));

			$(document).on('click', this.onDocumentClick.bind(this));

		}

		toggleMenu() {
			if (!this.isActive) {
				this.open();
			} else {
				this.close();
			}
		}

		open() {

			this.isActive = true;

			if (this.activeLevels.length < 1) {
				var $rootLevel = $('.' + this.settings.classes.level).first();
				this.activeLevels.unshift($rootLevel);
			}

			this.currentWidth = this.settings.width + ((this.activeLevels.length - 1) * this.settings.levelGap);

			this.$element.addClass(this.settings.classes.backdrop);

			this.$menu.css({
				width: this.currentWidth + 'px',
				left: 0
			});

			this.$content.css({
				left: this.currentWidth + 'px'
			});

			this.$smartHeader.css({
				left: this.currentWidth + 'px'
			});

			if (this.$shareBarFixed[0]) {
				this.$shareBarFixed.css({
					left: this.currentWidth + 'px'
				});
			}

			$.each(this.activeLevels, function(index, $level) {

				var overlayOperation = (index > 0) ? 'addClass' : 'removeClass';

				$level
					.css({
						left: (this.settings.levelGap * index) + 'px'
					})
					.addClass(this.settings.classes.active)
					[overlayOperation](this.settings.classes.overlay);

			}.bind(this));

		}

		onDocumentClick(e) {

			if (!this.isActive) {
				return;
			}

			// if the target of the click isn't the container...
			// nor a descendant of the container
			// nor the toggler
			// nor a descendant of the toggler
			if (
				!this.$menu.is(e.target) &&
				this.$menu.has(e.target).length === 0 &&
				!this.$toggler.is(e.target) &&
				this.$toggler.has(e.target).length === 0
			) {
				this.close();
			}

		}

		close(e) {

			this.isActive = false;

			this.$element.removeClass(this.settings.classes.backdrop);

			this.$menu.css({
				left: '-' + (this.currentWidth + this.settings.offsetAdjustment) + 'px'
			});

			this.$content.css({
				left: 0
			});


			this.$smartHeader.css({
				left: 0
			});

			if (this.$shareBarFixed[0]) {
				this.$shareBarFixed.css({
					left: 0
				});
			}

			$.each(this.activeLevels, function(index, $level) {
				$level.css({
					left: '-' + (this.settings.levelGap * index + this.settings.width + this.settings.offsetAdjustment) + 'px'
				});
			}.bind(this));

		}

		openSubmenu(e) {

			if (e) {
				e.preventDefault();
			}

			var $level = $(e.delegateTarget).siblings('.' + this.settings.classes.level);

			this.activeLevels.unshift($level);

			this.open();

		}

		hideSubmenu(e) {

			var $level = this.activeLevels.shift();

			$level
				.css({
					left: '-' + (this.settings.width + this.settings.offsetAdjustment) + 'px'
				})
				.removeClass(this.settings.classes.active);

			this.open();

		}

		selectSubmenu(e) {

			e.stopPropagation();

			var $submenu = $(e.target);

			if ($submenu.is('.' + this.settings.classes.header)) {
				$submenu = $(e.target).closest('.' + this.settings.classes.level);
			}

			if (!$submenu.hasClass(this.settings.classes.overlay)) {
				return;
			}

			var slicePoint = this.activeLevels.length - $submenu.index() - 1;

			var levelsToHide = this.activeLevels.slice(0, slicePoint);

			levelsToHide.map(this.hideSubmenu.bind(this));

			this.open();

		}

	}

	$.fn[pluginName] = function(options) {

		var args = arguments;

    if (options === undefined || typeof options === 'object') {
      return this.each(function() {
        if (!$.data(this, `plugin_${pluginName}`)) {
          $.data(this, `plugin_${pluginName}`, new MultilevelPushMenu(this, options));
        }
      });

    } else if (typeof options === 'string' && options[0] !== '_') {

      var returns;

      this.each(function() {

        var instance = $.data(this, `plugin_${pluginName}`);

        if (instance instanceof MultilevelPushMenu && typeof instance[options] === 'function') {
          returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        }

      });

      return returns !== undefined ? returns : this;

		}

	};

	$.fn[pluginName].defaults = {
		width: 260,
		offsetAdjustment: 3,
		levelGap: 42,
		menu: $('.mpl__menu'),
		submenus: $('.mpl__submenu'),
		content: $('.mpl__content'),
		smartHeader: $('.mpl__smart-header'),
		toggler: $('.mpl__toggler'),
		backButtons: $('.mpl__back'),
		shareBarFixed: $('.ads--fixo'),
		classes: {
			header: 'mpl__header',
			toggler: 'mpl__toggler',
			level: 'mpl__level',
			submenu: 'mpl__submenu',
			active: 'mpl--active',
			backdrop: 'mpl--backdrop',
			overlay: 'mpl--overlay'
		}
	};


})(jQuery, window, document);
